<template>
  <div class="header-icons">
    <div
      class="sort-icon align-items-center mr-2"
      :class="[cssMode, sortAlphabetical ? 'pointer' : 'selected-icon']"
      :title="$t('polls.ttSortingByDate')"
      v-on:click="onSortByDate()"
    >
      <font-awesome-icon class="" :icon="['fal', 'sort-numeric-down']" />
    </div>
    <div
      class="sort-icon mr-2"
      :class="[cssMode, !sortAlphabetical ? 'pointer' : 'selected-icon']"
      :title="$t('polls.ttSortingByName')"
    >
      <span
        v-on:click="onSortAlphabetical()"
        class="align-self-end"
        :class="[fontColor]"
      >
        <font-awesome-icon :icon="['fal', 'sort-alpha-down']" />
      </span>
    </div>
  </div>
</template>
<script>
import { renderMixin } from '../mixins/RenderMixins';
import { gridMixin } from '../mixins/GridMixins';
import sortParticipants from '@/shared/sortParticipants';
import {  mapGetters } from 'vuex';
export default {
  name: 'RendererSor5tingIcons',

  mixins: [renderMixin, gridMixin],

  methods: {
    onSortByDate() {
      this.sortAlphabetical = false;

      let participants = this.poll.participants;
      sortParticipants(participants, this.userId, this.sortAlphabetical);
      this.$store.commit('updateParticipants', participants);
    },

    onSortAlphabetical() {
      this.sortAlphabetical = true;
      let participants = this.poll.participants;
      sortParticipants(participants, this.userId, this.sortAlphabetical);
      this.$store.commit('updateParticipants', participants);
    },
  },

  computed: {
    ...mapGetters(['isOwner']),
    fontColor() {
      if (this.isDarkMode) {
        return 'white-color';
      }
      return 'dark-grey-color';
    },

  },
};
</script>

<style scoped lang="scss">
@import '@/styles/style';

.header-icons {
  display: flex;
  flex-direction: row;
}

.selected-icon {
  border-color: $primary;
  border-bottom: 2px solid $primary;
}
</style>
